import React from 'react';
import { colors } from '../constants';

const TouchpointIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M16.9129 6.73481C15.895 4.04192 13.3056 2.25 9.91578 2.25L9.69124 2.25319L9.68002 2.25352C5.77624 2.37026 2.57398 5.39539 2.57398 9.1998C2.57398 10.1576 2.77905 11.0712 3.14961 11.902C3.20859 12.0342 3.27175 12.1643 3.33891 12.2921L1.86784 14.5964C1.71845 14.8304 1.71055 15.1278 1.84729 15.3694C1.98403 15.611 2.24305 15.7573 2.52056 15.7497L2.64206 15.7464L2.66111 15.7456C3.47539 15.7026 4.63794 15.3337 6.08147 14.7278C6.4634 14.5675 6.64306 14.1279 6.48274 13.746C6.32243 13.364 5.88285 13.1844 5.50092 13.3447C4.96963 13.5677 4.50496 13.7453 4.10348 13.8821L4.84686 12.7176C5.00193 12.4747 5.0041 12.1644 4.85245 11.9194C4.72746 11.7174 4.61613 11.5076 4.51951 11.2909C4.23232 10.6471 4.07398 9.94124 4.07398 9.1998C4.07398 6.29205 6.54218 3.85074 9.7194 3.75302L9.92126 3.75C12.7451 3.75189 14.7337 5.21207 15.5098 7.26519C15.6563 7.65265 16.0891 7.84801 16.4766 7.70155C16.864 7.55509 17.0594 7.12226 16.9129 6.73481Z"
    />
    <path
      fill={props.color}
      d="M11.6 13.6C11.6 13.9314 11.3314 14.2 11 14.2C10.6686 14.2 10.4 13.9314 10.4 13.6C10.4 13.2686 10.6686 13 11 13C11.3314 13 11.6 13.2686 11.6 13.6Z"
    />
    <path
      fill={props.color}
      d="M13.6 13.6C13.6 13.9314 13.3314 14.2 13 14.2C12.6686 14.2 12.4 13.9314 12.4 13.6C12.4 13.2686 12.6686 13 13 13C13.3314 13 13.6 13.2686 13.6 13.6Z"
    />
    <path
      fill={props.color}
      d="M15 14.2C15.3314 14.2 15.6 13.9314 15.6 13.6C15.6 13.2686 15.3314 13 15 13C14.6686 13 14.4 13.2686 14.4 13.6C14.4 13.9314 14.6686 14.2 15 14.2Z"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 18C15.7615 18 18 15.9853 18 13.5C18 11.0147 15.7615 9 13 9C10.2386 9 8.00003 11.0147 8.00003 13.5C8.00003 15.9853 10.2386 18 13 18ZM13 16.5C15.0856 16.5 16.5 15.0121 16.5 13.5C16.5 11.9879 15.0856 10.5 13 10.5C10.9145 10.5 9.50003 11.9879 9.50003 13.5C9.50003 15.0121 10.9145 16.5 13 16.5Z"
    />
  </svg>
);

TouchpointIcon.defaultProps = {
  color: colors.mediumGrey,
};

export default TouchpointIcon;
